// content/fr.js — Source unique de toute la copie française.
// Direction : « instrument de précision suisse ». Catégorie : force de vente sociale autonome.
// Aucune promesse de revenu/vues/abonnés. Aucun faux témoignage/logo/chiffre. Aucun compte à rebours.

export const chf = (n) => {
  if (n === null || n === undefined) return "—";
  return "CHF\u00A0" + Number(n).toLocaleString("fr-CH").replace(/\s/g, "\u2019");
};
export const num = (n) => Number(n).toLocaleString("fr-CH").replace(/\s/g, "\u2019");

export const fr = {
  brand: { name: "VIRALYA", baseline: "Studio d'influenceurs IA", location: "Yverdon-les-Bains · Suisse romande" },
  nav: { methode: "Méthode", moteur: "Le Studio", offre: "Offre", angles: "Secteurs", faq: "FAQ", cta: "Essayer 7 jours" },

  hero: {
    badge: "Studio d'influenceurs IA · Suisse romande",
    title_1: "Créez et pilotez votre",
    title_grad: "influenceur IA",
    title_2: "qui vend pour vous, 24 h/24.",
    subtitle: "VIRALYA crée votre influenceur IA de A à Z, publie son contenu tous les jours sur Instagram, TikTok, Facebook et LinkedIn, lance ses lives TikTok, construit sa marque et sa boutique, répond aux DM et va chercher vos leads en organique. Sans caméra, sans équipe, sans vous.",
    cadrage: "Pas une agence d'influence : un commercial IA en organique. Il attire, qualifie et envoie vos leads frais vers vos pages de vente ou de rendez-vous — le closing reste chez vous.",
    lines: [
      "Un influenceur qui ne dort jamais : il publie, commente et prospecte pendant que vous gérez votre business.",
      "Un community manager en Suisse romande coûte 7 130 francs par mois, charges comprises.",
      "VIRALYA fait le travail d'une équipe complète, dès 197 francs par mois.",
    ],
    ctaPrimary: "Essayer 7 jours — 49 CHF",
    ctaSecondary: "Voir le studio produire en 9 minutes, sans coupure",
    note: "Cercle Fondateurs : 20 places, clôture le 30 novembre 2026",
    sourceNote: "Estimation Suisse romande : salaire mensuel brut d'un community manager + charges sociales employeur et frais annexes (~13,5 %).",
  },

  marquee: ["Influenceur IA créé de A à Z", "Contenu publié chaque jour", "Lives TikTok", "Marque + boutique", "DM & prospection organique", "Instagram · TikTok · Facebook · LinkedIn", "Édité en Suisse", "Facturé en francs"],

  personas: {
    eyebrow: "Vos influenceurs IA",
    title: "Des personnages qui vendent, prêts à publier.",
    lede: "Nous créons votre influenceur IA de A à Z — visage, voix, marque et boutique — puis il travaille tous les jours sur vos plateformes.",
    cards: [
      { img: "/img/persona-elena.jpg", nom: "Elena", niche: "Mode & lifestyle", canal: "Instagram · TikTok", etat: "Publié il y a 2 min" },
      { img: "/img/persona-maya.jpg", nom: "Maya", niche: "Beauté & cosmétique", canal: "TikTok Live · Instagram", etat: "Live TikTok en cours" },
      { img: "/img/persona-marco.jpg", nom: "Marco", niche: "Fitness & coaching", canal: "TikTok · YouTube", etat: "12 DM traités" },
      { img: "/img/persona-leo.jpg", nom: "Léo", niche: "Business & B2B", canal: "LinkedIn · Facebook", etat: "Planifié · 18:00" },
    ],
    team: "/img/team.jpg",
    teamEyebrow: "Votre roster",
    teamTitle: "Une équipe d'influenceurs IA, pilotée depuis une seule plateforme.",
    teamLede: "Chaque personnage a son univers et ses plateformes. Vous les gérez tous au même endroit : contenu, lives, DM, prospection et boutique.",
    dashTitle: "Tableau de bord",
    dashLive: "En direct",
    dashStats: [
      { v: "142", l: "contenus publiés / 7 j" },
      { v: "38", l: "DM traités aujourd'hui" },
      { v: "4", l: "plateformes actives" },
    ],
    capsTitle: "Ce que votre influenceur IA fait pour vous",
    caps: [
      "Création complète du personnage : visage, voix et style",
      "Contenu généré et publié chaque jour, en automatique",
      "Lives TikTok animés par votre influenceur",
      "Création de sa marque et de sa boutique qui vend",
      "Réponses aux DM et prise de contact proactive",
      "Acquisition de leads en organique sur Instagram, TikTok, Facebook et LinkedIn",
    ],
  },

  credibility: {
    eyebrow: "Crédibilité",
    title: "Ce que nous pouvons prouver, aujourd'hui.",
    facts: [
      { k: "Édité en Suisse", v: "Prix en francs suisses. Données hébergées en Suisse. Support en français." },
      { k: "Nos influenceurs IA en public", v: "Chiffres datés, publiés chaque semaine." },
      { k: "Quatre plateformes", v: "Instagram, TikTok, Facebook et LinkedIn, via les API officielles." },
      { k: "Méthode verrouillée", v: "Seize étapes documentées, de la création au pilotage." },
      { k: "Connecté à Loomy CRM & Talk-Flow", html: true, v: "Viralya attire et chauffe vos leads ; dès qu'un lead est prêt à être converti, il passe dans <a href=\"https://app.loomy-crm.com\" target=\"_blank\" rel=\"noopener\">Loomy CRM</a> pour la vente. Et nous sommes connectés à <a href=\"https://talk-flow.ai\" target=\"_blank\" rel=\"noopener\">Talk-Flow</a> pour des relances client directes par appel." },
    ],
  },

  problem: {
    eyebrow: "Le problème",
    title: "Sans influenceur IA, tout repose sur vous",
    days: [
      { j: "Lundi", d: "Vous notez trois idées de contenu. Aucune n'est tournée." },
      { j: "Mardi", d: "Vous tournez, la lumière est mauvaise, vous recommencez." },
      { j: "Mercredi", d: "Le montage prend deux heures de plus que prévu." },
      { j: "Jeudi", d: "Vous publiez sur un seul compte, puis vous rafraîchissez les vues." },
      { j: "Vendredi", d: "Les DM et commentaires s'accumulent, sans réponse." },
    ],
    punchline: "Le samedi, vous regardez les chiffres. Vues en hausse. Compte en banque identique.",
    enemy: "L'ennemi n'est pas l'algorithme. L'ennemi, c'est de devoir être vous-même l'influenceur, le monteur et le community manager de votre entreprise.",
  },

  timesaved: {
    eyebrow: "Démonstration",
    title: "Fonction par fonction : ce que la machine fait, et ce que ça vous rend",
    head: ["#", "Fonction", "À la main", "Avec Viralya", "Heures rendues"],
    rows: [
      ["1", "Veille concurrentielle automatisée", "3 h 00", "0 h 00", "3 h 00"],
      ["2", "Analyse de niche", "1 h 00", "0 h 00", "1 h 00"],
      ["3", "Scripts et accroches, 28 par semaine", "4 h 30", "0 h 00", "4 h 30"],
      ["4", "Storyboard automatique", "1 h 00", "0 h 00", "1 h 00"],
      ["5", "Visuels et décors IA", "1 h 30", "0 h 00", "1 h 30"],
      ["6", "Tournage remplacé, personnage IA, lip-sync", "4 h 00", "0 h 00", "4 h 00"],
      ["7", "Voix clonée cohérente", "1 h 30", "0 h 00", "1 h 30"],
      ["8", "Montage, effets sonores, assemblage", "6 h 20", "0 h 00", "6 h 20"],
      ["9", "Sous-titres et formats verticaux", "3 h 00", "0 h 00", "3 h 00"],
      ["10", "Recyclage automatique, 3 à 5 dérivés", "3 h 45", "0 h 00", "3 h 45"],
      ["11", "Publication multicanal programmée", "2 h 45", "0 h 00", "2 h 45"],
      ["12", "Réponses aux commentaires (dès Growth)", "2 h 00", "0 h 00", "2 h 00"],
      ["13", "Messages privés qualifiés", "3 h 30", "1 h 00", "2 h 30"],
      ["14", "Prospection proactive (dès Growth)", "2 h 00", "0 h 00", "2 h 00"],
      ["—", "Rapport et décisions", "1 h 30", "0 h 45", "0 h 45"],
    ],
    negative: ["—", "Contrôle qualité et validation (travail nouveau, à votre charge)", "0 h 00", "1 h 30", "− 1 h 30"],
    total: ["Total", "41 h 20", "3 h 15", "38 h 05"],
    reading: "Lecture honnête du tableau : le contrôle qualité est un travail que vous n'aviez pas avant et que vous aurez avec Viralya. Il est compté en négatif. Nous ne le cachons pas dans une colonne.",
    conversion: [
      { v: "1 485 CHF", l: "par semaine (38 h 05 à 39 CHF/h)" },
      { v: "6 435 CHF", l: "par mois (165 heures rendues)" },
      { v: "77 220 CHF", l: "par an (1 980 heures)" },
    ],
    closing: "Le plan Growth coûte 497 francs par mois. Ce n'est pas une remise. C'est un changement de nature du poste : vous ne payez plus des heures, vous payez une machine qui tourne.",
    sourceNote: "39 CHF/h = coût horaire chargé d'un profil marketing junior en Suisse romande (salaire brut + charges sociales employeur).",
  },

  pacte: {
    eyebrow: "La Boucle PACTE",
    title: "Un outil vous donne des vidéos. VIRALYA vous donne un influenceur qui vend.",
    steps: [
      { l: "P", t: "Positionnement", timing: "Jour 1 à 3", d: "On décide ce que vous vendez avant de décider ce que vous publiez.", contre: "Publier d'abord, réfléchir à ce qu'on vend ensuite." },
      { l: "A", t: "Avatar", timing: "Jour 3 à 7", d: "Un personnage, un seul, qui ne change jamais de visage ni de voix.", contre: "Changer de format et de tête tous les mois." },
      { l: "C", t: "Cadence", timing: "Jour 8 à 14, puis en continu", d: "La machine publie tous les jours, sur plusieurs plateformes, sans vous.", contre: "Publier par à-coups, quand on a le temps." },
      { l: "T", t: "Traction", timing: "En continu, 24 h sur 24", d: "Elle répond. Aux commentaires, puis aux messages privés, avec la même voix.", contre: "Laisser les commentaires et les DM sans réponse." },
      { l: "E", t: "Encaissement", timing: "En continu, rapport mensuel", d: "Vous ne parlez qu'aux gens qui valent la peine. Et la machine apprend d'eux.", contre: "Parler à tout le monde, ne rien mesurer." },
    ],
    stepE_bold: "Ce que la machine apprend des conversations réécrit le positionnement du mois suivant. Retour à P.",
    closing: "La différence, c'est l'étape E.",
  },

  pricing: {
    eyebrow: "Tarifs",
    title: "Comparez d'abord ce que ça remplace.",
    anchors: [
      { k: "Community manager interne, Suisse romande", v: "7 130 CHF", d: "charges comprises · 1 personne, 42 h/semaine, ~68 contenus/mois" },
      { k: "Agence de contenu romande", v: "2 500–4 000 CHF", d: "12 à 20 contenus/mois, 0 message privé traité" },
      { k: "Vous, le soir et le week-end", v: "6 981 CHF", d: "de votre temps à 39 CHF/h, 41 h 20 par semaine" },
    ],
    anchorFinal: { k: "Viralya Growth", v: "497 CHF", d: "~150 contenus/mois, 4 plateformes, commentaires, DM qualifiés, prospection, rapport mensuel" },
    plans: [
      { nom: "Starter", prix: "197 CHF/mois", detail: ["200 crédits", "1 à 2 contenus/jour", "2 plateformes", "3,94 CHF le contenu", "support self-service"], ref: false },
      { nom: "Growth", prix: "497 CHF/mois", detail: ["600 crédits", "3 à 5 contenus/jour", "4 plateformes", "commentaires + prospection", "rapport mensuel", "3,31 CHF le contenu", "support 48 h"], ref: true },
      { nom: "Brand", prix: "797 CHF/mois", detail: ["1 000 crédits", "8 à 10 contenus/jour", "toutes plateformes", "1 boutique + marque complète", "2,66 CHF le contenu", "support 24 h"], ref: false },
    ],
    refLabel: "Le plan de référence",
    onRequest: [
      { nom: "Agency", prix: "2 197 CHF/mois", d: "Souscription après un audit de 20 minutes. Clause d'usage équitable." },
      { nom: "Marque Blanche", prix: "3 497 CHF/mois", d: "Souscription après un audit de 20 minutes. Clause d'usage équitable." },
    ],
    onRequestCta: "Demander un audit",
    launch: {
      title: "Programme de Lancement 14 jours",
      lines: ["297 CHF avec Growth", "1 497 CHF avec Brand", "payable en trois fois"],
      note: "Nous ne l'offrons pas, et c'est volontaire. Ce qui est offert n'est pas exécuté.",
    },
    ctaPilote: "Essayer 7 jours — 49 CHF",
  },

  proof: {
    eyebrow: "La preuve",
    title: "Nos personnages travaillent en public. Allez vérifier.",
    lede: "Chaque lundi, nous publions les chiffres bruts de nos deux personnages, avec les captures d'analytics natives et leur date. Les mauvaises semaines comme les bonnes.",
    caseStudyBadge: "Étude interne Viralya — ce n'est pas un résultat client",
    characters: [
      { nom: "Elena Morel", desc: "Image et désir premium", canaux: "Instagram · TikTok", ia: true, badge: "Première mesure le lundi 12 octobre 2026" },
      { nom: "Nathan Keller", desc: "Croissance et retour sur investissement", canaux: "LinkedIn · Shorts · X", ia: true, badge: "Première mesure le lundi 12 octobre 2026" },
      { nom: "Viralya", desc: "La marque, en public", canaux: "LinkedIn Page · YouTube · Facebook", ia: false, badge: "Compte de marque" },
    ],
    rule: "Règle de publication : aucun chiffre n'est affiché sans capture d'analytics native datée. Un chiffre non prouvable est retiré, jamais arrondi. Les mauvaises semaines sont publiées comme les bonnes.",
    defect: "Notre point faible connu au 12 août 2026 : l'enchaînement entre deux scènes n'est pas encore fluide.",
  },

  competitive: {
    eyebrow: "Comparatif honnête",
    title: "Où les autres nous battent",
    losses: [
      "HeyGen et Synthesia font de plus belles vidéos que nous.",
      "Buffer et Later programment mieux que nous.",
      "Jasper écrit mieux les textes longs que nous.",
    ],
    closing: "Chacun d'eux est excellent sur son segment de la boucle. Aucun ne la referme.",
  },

  guarantee: {
    eyebrow: "Garantie",
    title: "Garantie Première Traction — 30 jours",
    thresholds: [
      { v: "150", l: "contenus publiés" },
      { v: "5", l: "plateformes actives" },
      { v: "30", l: "messages privés traités" },
    ],
    promise: "…sinon votre deuxième mois est offert.",
    exclusionsTitle: "Ce que la garantie ne couvre pas",
    exclusions: [
      "Aucune garantie de revenu.",
      "Aucune garantie de vues.",
      "Aucune garantie d'abonnés.",
      "Aucune garantie de taux de conversion.",
    ],
  },

  founders: {
    eyebrow: "Cercle Fondateurs",
    title: "20 places, clôture le 30 novembre 2026",
    prices: [
      { nom: "Starter", prix: "137,90 CHF" },
      { nom: "Growth", prix: "347,90 CHF" },
      { nom: "Brand", prix: "557,90 CHF" },
    ],
    subtitle: "−30 % à vie. En échange : un témoignage signé après 60 jours et le droit de citer vos chiffres.",
    counterNote: "Ce compteur est mis à jour à la main, sous 24 heures ouvrables, après chaque souscription confirmée. Il ne bouge pas tout seul. Il n'y a pas d'horloge qui tourne sur cette page.",
    counterLabel: "Places attribuées",
  },

  transparency: {
    eyebrow: "Transparence",
    title: "Ce que nous promettons — et ce que non",
    rows: [
      { p: "Une mesure fiable comme base de décision", n: "Un revenu, des vues ou des abonnés garantis" },
      { p: "Des personnages clairement identifiés comme IA", n: "Faire passer un personnage IA pour un humain" },
      { p: "Nos mauvaises semaines publiées comme les bonnes", n: "Des chiffres de preuve inventés" },
    ],
  },

  roi: {
    eyebrow: "Simulateur",
    title: "Capacité de production (illustratif)",
    disclaimer: "Simulation purement illustrative à partir de vos entrées — ni promesse, ni projection garantie.",
    fields: { videosJour: "Contenus / jour visés", canaux: "Nombre de plateformes", jours: "Jours / mois actifs" },
    result: "Contenus produits / mois (estimé)",
  },

  faq: {
    eyebrow: "FAQ",
    title: "Questions fréquentes",
    items: [
      { q: "Les personnages sont-ils déclarés comme IA ?", a: "Oui. Le statut IA est accessible en moins d'un clic et n'est jamais nié. Les personnages générés par intelligence artificielle sont signalés comme tels sur chaque plateforme. Nous ne revendiquons jamais une fausse identité humaine." },
      { q: "Quel est votre point faible connu ?", a: "L'enchaînement entre deux scènes n'est pas encore fluide, au 12 août 2026. Nous ne promettons pas une qualité de cinéma. Nous le mentionnons ouvertement plutôt que de le cacher." },
      { q: "Garantissez-vous des résultats commerciaux ?", a: "Non. Nous garantissons un volume de production et de traitement (150 contenus, 5 plateformes, 30 messages privés en 30 jours), pas un revenu, ni des vues, ni des abonnés, ni un taux de conversion." },
      { q: "Combien de contenus par jour ?", a: "1 à 2 par jour en Starter, 3 à 5 dès Growth, 8 à 10 dès Brand. Le volume dépend de votre plan." },
      { q: "Comment gérez-vous mes données ?", a: "Conformité LPD/nLPD, consentement journalisé, aucun traceur avant votre choix. Les paiements passent par Stripe ; aucune donnée complète de carte n'est stockée." },
    ],
  },

  qualification: {
    eyebrow: "Candidature",
    title: "Parlez-nous de votre activité",
    subtitle: "Quelques informations pour préparer votre pilote. Réponse sous 48 h ouvrées.",
    fields: { nom: "Nom complet", email: "E-mail professionnel", entreprise: "Entreprise", profil: "Votre profil", message: "Votre niche en une phrase (facultatif)" },
    profils: [
      { v: "ecommerce", l: "E-commerce" },
      { v: "infopreneur", l: "Infopreneur" },
      { v: "agence", l: "Agence" },
      { v: "freelance", l: "Freelance / indépendant" },
    ],
    submit: "Envoyer ma candidature",
    success: "Candidature reçue. Nous revenons vers vous sous 48 h ouvrées.",
    error: "Un problème est survenu. Merci de réessayer.",
  },

  finalCta: { eyebrow: "Décision", title: "Lancez votre influenceur IA.", body: "Arrêtez d'être l'influenceur de votre propre entreprise. Laissez VIRALYA créer, publier et vendre à votre place.", cta: "Essayer 7 jours — 49 CHF" },

  footer: {
    tagline: "Studio d'influenceurs IA. Édité en Suisse, à Yverdon-les-Bains.",
    columns: [
      { t: "Produit", links: [
        { l: "Le Moteur", to: "/#moteur" }, { l: "La Boucle PACTE", to: "/#methode" },
        { l: "Essayer 7 jours", to: "/pilote" }, { l: "Démonstration", to: "/demonstration" },
        { l: "Tarifs", to: "/prix" }, { l: "FAQ", to: "/#faq" }, { l: "Journal", to: "/journal" },
      ]},
      { t: "Légal", links: [
        { l: "Mentions légales", to: "/legal/mentions" }, { l: "LPD / nLPD", to: "/legal/confidentialite" },
        { l: "CGV", to: "/legal/cgv" }, { l: "Sous-traitants", to: "/legal/sous-traitants" },
        { l: "Cookies & consentement", to: "/legal/cookies" }, { l: "Transparence IA", to: "/legal/transparence-ia" },
      ]},
      { t: "Contact", links: [
        { l: "Réserver un audit", to: "/audit" }, { l: "Cercle Fondateurs", to: "/cercle-fondateurs" },
        { l: "Le compteur", to: "/compteur" }, { l: "Agences & revendeurs", to: "/agences" }, { l: "Programme d'affiliation", to: "/affiliation" }, { l: "Yverdon-les-Bains · Suisse", to: "/#top" },
      ]},
    ],
    legalNote: "© " + new Date().getFullYear() + " Homely Solutions Sàrl — VIRALYA. Yverdon-les-Bains, Suisse. Contenus générés par IA et signalés comme tels.",
    manageCookies: "Gérer mes cookies",
  },

  consent: {
    title: "Votre confidentialité",
    body: "Cookies de mesure utilisés uniquement avec votre consentement. Aucun traceur avant votre choix (LPD / RGPD).",
    accept: "Tout accepter", refuse: "Tout refuser",
  },

  theme: { toLight: "Passer en clair", toDark: "Passer en sombre" },

  // Funnel
  pilote: {
    eyebrow: "Pilote 7 jours",
    title: "Sept jours pour voir votre influenceur IA publier et répondre.",
    subtitle: "Un pilote encadré à 49 CHF. Paiement unique, aucun abonnement déclenché.",
    notTitle: "Ce que le pilote ne fait pas",
    notList: [
      "Pas d'étape E (encaissement) sur 7 jours.",
      "Deux plateformes seulement.",
      "Pas de prospection proactive.",
      "Pas de boutique.",
      "Aucune preuve de revenu en 7 jours.",
    ],
    fields: { nom: "Nom complet", email: "E-mail", entreprise: "Entreprise", telephone: "Téléphone (facultatif)" },
    next: "Continuer vers la commande",
  },
  commande: {
    eyebrow: "Commande",
    title: "Récapitulatif & paiement",
    activiteLabel: "Votre activité",
    activiteOptions: [
      { v: "ecommerce", l: "E-commerce" }, { v: "infopreneur", l: "Infopreneur" },
      { v: "agence", l: "Agence" }, { v: "freelance", l: "Freelance / indépendant" },
      { v: "autre", l: "Autre" },
    ],
    nicheLabel: "Votre niche, en une phrase",
    bumpLabel: "Ajouter la Character Bible complète",
    bumpBody: "Le document de référence de votre personnage : 3 tenues signature, 3 décors, prompts image et vidéo, protocole de cohérence. Vous le gardez et le réutilisez ailleurs, même si vous arrêtez le pilote.",
    payer: "Payer et lancer mon pilote",
    demoNote: "Paiement unique. Aucun abonnement déclenché. Aucune carte re-prélevée au jour 7. Les 49 CHF sont déduits de votre premier mois si vous continuez. Paiement sécurisé par Stripe (mode test — carte 4242 4242 4242 4242).",
    trustMarks: ["Facturé en CHF", "Hébergé en Suisse", "LPD & RGPD", "Résiliable en 2 clics"],
    baseLabel: "Pilote 7 jours",
    total: "Total",
  },
  merci: {
    eyebrow: "Confirmation",
    title: "Merci — votre pilote est lancé",
    body: "Votre paiement est confirmé. Un e-mail de confirmation vous a été envoyé.",
    pending: "Confirmation du paiement en cours…",
    onboardTitle: "Répondez aux 9 questions de cadrage — 12 minutes",
    onboard: [
      { t: "Cadrage de niche", d: "On clarifie ce que vous vendez avant ce que vous publiez." },
      { t: "Connexion des comptes", d: "On relie vos plateformes via les API officielles." },
      { t: "Validation du personnage", d: "On valide le visage et la voix de votre personnage IA." },
    ],
    upsellTitle: "Programme de Lancement 14 jours",
    upsellDesc: "Accélérez votre mise en place sur 14 jours. Ajout en un clic sur votre carte enregistrée. Nous ne l'offrons pas : ce qui est offert n'est pas exécuté.",
    upsellCta: "Oui, ajouter",
    upsellDone: "Programme de Lancement ajouté — merci !",
    upsellError: "Le paiement a été refusé. Réessayez ou changez de carte.",
    home: "Retour à l'accueil",
  },
  challenge: {
    eyebrow: "Challenge gratuit",
    badge: "5 jours · 100 % en ligne · gratuit",
    title_1: "Le Challenge",
    title_grad: "Vidéo IA",
    title_2: "en 5 jours",
    subtitle: "Cinq jours pour lancer votre premier personnage IA et vos premières publications. Un e-mail par jour, des actions concrètes, zéro blabla.",
    days: [
      { j: "Jour 1", t: "Votre positionnement", d: "Décider ce que vous vendez avant ce que vous publiez." },
      { j: "Jour 2", t: "Votre personnage", d: "Créer et calibrer votre présentateur IA en français." },
      { j: "Jour 3", t: "L'accroche", d: "Écrire des hooks qui arrêtent le scroll." },
      { j: "Jour 4", t: "La cadence", d: "Programmer la publication multicanal." },
      { j: "Jour 5", t: "La mesure", d: "Publier, lire les signaux, décider de la suite." },
    ],
    formTitle: "Réserver ma place",
    fields: { nom: "Prénom", email: "E-mail", profil: "Votre profil" },
    submit: "Rejoindre le Challenge",
    success: "Bienvenue ! Vérifiez votre boîte mail — le Jour 1 arrive.",
    error: "Un problème est survenu. Merci de réessayer.",
  },
  partenaires: {
    eyebrow: "Programme Partenaires",
    title_1: "Devenez",
    title_grad: "agence partenaire",
    title_2: "VIRALYA",
    subtitle: "Revendez la force de vente sociale autonome à vos clients en marque blanche. Vous gardez la relation, on fournit le moteur et la mesure.",
    perks: [
      { t: "Marge récurrente", d: "Une rémunération sur chaque client que vous apportez et gérez." },
      { t: "Marque blanche", d: "Le moteur à vos couleurs, sous votre relation client." },
      { t: "Pipeline scalable", d: "Produisez pour tous vos comptes sans staffer des monteurs." },
      { t: "Accompagnement", d: "Onboarding, ressources et support dédié partenaires." },
    ],
    formTitle: "Candidater au programme",
    fields: { nom: "Nom complet", email: "E-mail professionnel", agence: "Nom de l'agence", site: "Site web", clients: "Nombre de clients actifs", message: "Parlez-nous de votre agence" },
    submit: "Envoyer ma candidature",
    success: "Candidature reçue. Notre équipe partenaires vous recontacte rapidement.",
    error: "Un problème est survenu. Merci de réessayer.",
  },
  ad: {
    cta: "Essayer 7 jours — 49 CHF",
    sub: "Sans engagement · Réponse sous 48 h ouvrées",
    stickyCta: "Essayer 7 jours",
  },

  angles: { eyebrow: "Secteurs", title: "Un déploiement par cas d'usage", cta: "Voir cet angle" },

  offer: { cta: "Essayer 7 jours", bumpTitle: "Character Bible", bump: "Cadrage éditorial complet de votre personnage IA : ton, valeurs, tabous et formats." },

  noyau: {
    eyebrow: "L'instrument",
    title: "Le Noyau",
    subtitle: "Un mécanisme de précision qui referme la boucle.",
    steps: [
      { id: 1, label: "01 · Repos", desc: "L'instrument au repos : un personnage, une voix, une promesse claire." },
      { id: 2, label: "02 · Diffusion", desc: "Il se déploie sur cinq plateformes, via les API officielles uniquement." },
      { id: 3, label: "03 · Identité", desc: "Le personnage garde le même visage et la même voix, partout, tout le temps." },
      { id: 4, label: "04 · Boucle PACTE", desc: "Vue éclatée : Positionnement, Avatar, Cadence, Traction, Encaissement." },
      { id: 5, label: "05 · Production", desc: "Le contenu sort en continu : scripts, montage, sous-titres, formats verticaux." },
      { id: 6, label: "06 · Décision", desc: "La mesure remonte, le positionnement se réécrit. Retour au juste prix." },
    ],
  },

  specs: {
    eyebrow: "Spécifications",
    title: "Ce qui tourne sous le capot",
    rows: [
      { k: "Personnages IA", v: "Présentateurs numériques calibrés, voix FR-CH" },
      { k: "Plateformes", v: "5 canaux via API officielles" },
      { k: "Sous-titres", v: "Génération et incrustation FR automatiques" },
      { k: "Mesure", v: "Suivi serveur, source de vérité unique" },
      { k: "Accessibilité", v: "WCAG AA · cibles 44 px · focus visibles" },
      { k: "Confidentialité", v: "Aucun traceur avant consentement (LPD)" },
    ],
  },

  admin: {
    loginTitle: "Espace Admin",
    loginSub: "Connexion réservée à l'équipe VIRALYA.",
    email: "E-mail", password: "Mot de passe", loginBtn: "Se connecter",
    nav: { dashboard: "Tableau de bord", angles: "Angles", leads: "Leads", orders: "Commandes", partners: "Partenaires", challenge: "Challenge", config: "Configuration" },
    logout: "Déconnexion",
  },

  legal: {
    updated: "Document de démonstration — à faire valider par votre conseil juridique.",
    docs: {
      mentions: {
        title: "Mentions légales",
        sections: [
          { h: "Éditeur", p: "VIRALYA est édité par Homely Solutions Sàrl, Rue Jean André Venel 4, 1400 Yverdon-les-Bains, Suisse. Contact : hello@viralya.io. IDE à compléter par l'éditeur." },
          { h: "Directeur de la publication", p: "À compléter par l'éditeur." },
          { h: "Hébergement", p: "Application hébergée sur une infrastructure cloud. Détails de l'hébergeur à compléter." },
          { h: "Propriété intellectuelle", p: "L'ensemble des contenus (textes, visuels, marques) est la propriété de Homely Solutions Sàrl ou de ses partenaires, sauf mention contraire. Toute reproduction sans autorisation est interdite." },
          { h: "Infrastructure & acquisition", p: "Infrastructure digitale et acquisition client : Darven." },
        ],
      },
      confidentialite: {
        title: "Confidentialité — LPD / nLPD",
        sections: [
          { h: "Responsable du traitement", p: "Homely Solutions Sàrl traite vos données conformément à la Loi fédérale sur la protection des données (nLPD) et, le cas échéant, au RGPD." },
          { h: "Données collectées", p: "Formulaires de candidature (nom, e-mail, entreprise, message), commandes (identité, coordonnées, montant) et données de mesure soumises à consentement." },
          { h: "Finalités", p: "Gestion des candidatures et commandes, exécution du service, mesure d'audience après consentement, respect des obligations légales." },
          { h: "Base légale", p: "Consentement, exécution contractuelle et intérêt légitime selon le traitement concerné." },
          { h: "Durée de conservation", p: "Les données sont conservées le temps nécessaire aux finalités puis supprimées ou anonymisées. Durées précises à définir par l'éditeur." },
          { h: "Vos droits", p: "Accès, rectification, effacement, opposition et portabilité, traités sous 30 jours. Pour exercer vos droits, contactez l'éditeur à l'adresse des mentions légales." },
          { h: "Paiements", p: "Les paiements sont traités par Stripe ; aucune donnée complète de carte n'est stockée par VIRALYA." },
        ],
      },
      cookies: {
        title: "Cookies & consentement",
        sections: [
          { h: "Principe", p: "Aucun traceur de mesure n'est déposé avant votre consentement. Le refus a le même poids visuel que l'acceptation." },
          { h: "Catégories", p: "Cookies strictement nécessaires (toujours actifs) et cookies de mesure (soumis à votre consentement)." },
          { h: "Journal de consentement", p: "Chaque choix (accepter / refuser) est journalisé côté serveur, avec horodatage, à des fins de preuve de conformité." },
          { h: "Modifier votre choix", p: "Vous pouvez rouvrir la bannière et changer votre choix à tout moment via le bouton « Gérer mes cookies » en pied de page." },
        ],
      },
      "transparence-ia": {
        title: "Transparence IA",
        sections: [
          { h: "Statut IA en un clic", p: "Le statut IA de chaque personnage est accessible en moins d'un clic et n'est jamais nié lorsqu'il est demandé." },
          { h: "Aucune fausse identité humaine", p: "Nous ne revendiquons jamais qu'un personnage IA est une personne réelle. Aucun faux compte, aucune automatisation clandestine." },
          { h: "Voix de synthèse", p: "Les voix peuvent être synthétiques ou clonées avec autorisation. Toute voix clonée nécessite le consentement explicite de la personne concernée." },
          { h: "Défauts publiés", p: "Nos limites connues sont publiées, y compris l'enchaînement de scènes non encore fluide. Nous n'affichons ni témoignages, ni logos, ni chiffres inventés." },
        ],
      },
      cgv: {
        title: "Conditions générales de vente",
        sections: [
          { h: "Objet", p: "Les présentes CGV régissent la vente des services VIRALYA édités par Homely Solutions Sàrl : Programme Pilote, abonnements (Starter, Growth, Brand) et prestations associées." },
          { h: "Prix et paiement", p: "Les prix sont indiqués en francs suisses (CHF), taxes éventuelles en sus. Le paiement s'effectue par carte via Stripe. Le Programme Pilote est un paiement unique de 49 CHF, sans abonnement déclenché." },
          { h: "Droit de rétractation et remboursement", p: "Les modalités de rétractation et la Garantie Première Traction (30 jours) sont décrites sur la page de l'offre. Aucun résultat commercial (revenu, vues, abonnés) n'est garanti." },
          { h: "Abonnements et résiliation", p: "Les abonnements sont mensuels et résiliables en deux clics depuis l'espace client. La résiliation prend effet à la fin de la période en cours." },
          { h: "Responsabilité", p: "VIRALYA fournit un volume de production et de traitement, sans garantie de performance commerciale. La responsabilité de l'éditeur est limitée au montant payé sur le mois concerné." },
          { h: "Droit applicable", p: "Les présentes CGV sont soumises au droit suisse. For juridique : Yverdon-les-Bains, sous réserve des dispositions impératives. Document de démonstration à faire valider par votre conseil juridique." },
        ],
      },
      "sous-traitants": {
        title: "Sous-traitants et hébergement des données",
        sections: [
          { h: "Principe", p: "Conformément à la LPD/nLPD et au RGPD, nous listons les sous-traitants qui traitent des données personnelles pour le compte de VIRALYA." },
          { h: "Paiements", p: "Stripe (traitement des paiements). Aucune donnée complète de carte n'est stockée par VIRALYA." },
          { h: "Hébergement & infrastructure", p: "Fournisseur d'infrastructure cloud pour l'hébergement de l'application et de la base de données. Localisation et détails à compléter par l'éditeur." },
          { h: "E-mails transactionnels", p: "Prestataire d'envoi d'e-mails pour les confirmations de commande et l'onboarding. À compléter par l'éditeur." },
          { h: "Mesure d'audience", p: "Outil de mesure activé uniquement après consentement. Aucune donnée de mesure n'est transmise avant votre choix." },
          { h: "Vos droits", p: "Vous pouvez demander la liste à jour des sous-traitants et exercer vos droits d'accès et d'effacement à l'adresse indiquée dans les mentions légales." },
        ],
      },
    },
  },
};
